<div class="flex items-start justify-between gap-md">
  <h3 class="reset-h text-lg font-semibold text-default">{{ card().title }}</h3>

  @if (isMatched()) {
    <sb-badge class="shrink-0" [color]="'green'">{{ 'Matched' | translate }}</sb-badge>
  } @else {
    <sb-badge class="shrink-0" [color]="'yellow'">{{ 'To decide' | translate }}</sb-badge>
  }
</div>

@for (row of rows(); track row.key) {
  <div class="flex flex-col gap-sm">
    @if (isGroup()) {
      <h4 class="reset-h text-base font-semibold text-default">{{ row.entry.title }}</h4>
    }

    <p class="reset-p text-base text-support" data-hj-suppress>{{ row.entry.anchorText }}</p>

    <sb-radio-group
      class="flex flex-col gap-sm"
      [orientation]="'vertical'"
      [attr.aria-label]="row.entry.title"
      [ngModel]="row.selected"
      (ngModelChange)="choose(row, $event)"
    >
      @for (option of row.options; track option.id) {
        @if (option.match; as match) {
          @if (match.type === 'existing') {
            <sb-radio
              [value]="option.id"
              [label]="'Use [title], a field you already have' | translate: { title: '{' + match.variable + '}' }"
              [description]="'No new field is created.' | translate"
            />
          } @else {
            <sb-radio
              [value]="option.id"
              [label]="'Create a new field' | translate"
              [description]="'Added to your fields, so other templates can use it too.' | translate"
            />

            @if (row.selected === option.id && row.newField; as newField) {
              <div class="flex flex-col gap-xs pl-xl">
                <div class="grid grid-cols-2 items-start gap-md">
                  <sb-form-field
                    [label]="'Name' | translate"
                    [overrideError]="row.unnamed"
                    [overrideErrorMessage]="'Must contain at least one letter or number' | translate"
                  >
                    <input
                      #nameInput
                      sbInput
                      type="text"
                      [value]="newField.label"
                      (input)="rename(row, newField, nameInput.value)"
                    />
                    <span class="block text-sm text-support">{{ row.variable }}</span>
                  </sb-form-field>

                  @if (newField.fieldType === 'select') {
                    <sb-form-field [label]="'Type' | translate">
                      <span ngProjectAs="label-suffix" class="text-sm text-subtle">{{ 'locked' | translate }}</span>
                      <sb-select [items]="lockedTypeOptions" [selected]="'select'" [disabled]="true" />
                    </sb-form-field>
                  } @else {
                    <sb-form-field [label]="'Type' | translate">
                      <sb-select
                        [items]="typeOptions"
                        [selected]="newField.fieldType"
                        (selectedChange)="retype(row, newField, $event)"
                      />
                    </sb-form-field>
                  }
                </div>

                @if (newField.fieldType === 'select') {
                  <p class="reset-p text-sm text-support">
                    {{ 'Always Select. The choices come from your document.' | translate }}
                  </p>
                }
              </div>
            }
          }
        } @else {
          <sb-radio
            data-hj-suppress
            [value]="option.id"
            [label]="'Keep as written' | translate"
            [description]="'Every contract says &quot;[text]&quot;.' | translate: { text: row.entry.anchorText }"
          />
        }
      }
    </sb-radio-group>
  </div>
}
